const API_BASE = "https://sangitshreeprakashan.com/backend/api";
export default API_BASE;